const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_COURSES_LIST",
  FETCH_LIST_REQUEST: "FETCH_COURSES_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_COURSES_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_COURSES_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_COURSES_LIST",
}

export default LIST_ACTION_TYPES
